import { http } from '@/lib/http';

/**
 * Per the BE Prisma model — kept narrow to what the FE renders.
 * Adjust as we expose more fields server-side.
 */
export interface SecuritySeal {
  id: string;
  code: string;
  status: 'APPLIED' | 'RECEIVED_INTACT' | 'RECEIVED_BROKEN' | 'VOIDED';
  dispatchOrderItemId: string;
  appliedAt: string;
  appliedByUserId?: string | null;
  receivedAt?: string | null;
  receivedByUserId?: string | null;
  receivedDuringReturnId?: string | null;
  brokenReason?: string | null;
  voidedAt?: string | null;
  voidReason?: string | null;
}

export interface SecuritySealWithDispatch extends SecuritySeal {
  dispatchOrderItem: {
    id: string;
    sku: string;
    name: string;
    quantity: string;
    dispatchOrderId: string;
    salesOrderItemId: string;
  };
}

export interface ApplySealsPayload {
  codes: string[];
}

export interface ReceiveSealPayload {
  returnOrderId: string;
  intact: boolean;
  brokenReason?: string;
}

export interface VoidSealPayload {
  reason: string;
}

const ITEM_BASE = '/api/v1/dispatch/items';
const SEAL_BASE = '/api/v1/security-seals';

export const securitySealsService = {
  /** Pack-time: attach 1..N codes to a dispatch line. */
  applyToLine: (dispatchItemId: string, payload: ApplySealsPayload) =>
    http.post<SecuritySeal[], ApplySealsPayload>(
      `${ITEM_BASE}/${dispatchItemId}/seals`,
      payload,
    ),

  /** Return intake: translate a scanned code to its originating line. */
  lookupByCode: (code: string) =>
    http.get<SecuritySealWithDispatch>(`${SEAL_BASE}/${encodeURIComponent(code)}`),

  /** Return intake: record intact / broken against a return. */
  recordReceive: (code: string, payload: ReceiveSealPayload) =>
    http.post<SecuritySeal, ReceiveSealPayload>(
      `${SEAL_BASE}/${encodeURIComponent(code)}/receive`,
      payload,
    ),

  /** Admin: void a misapplied tag. */
  void: (id: string, payload: VoidSealPayload) =>
    http.post<SecuritySeal, VoidSealPayload>(
      `${SEAL_BASE}/${id}/void`,
      payload,
    ),
};
